/*
 * @Description:
 * @Author: 山淑兰
 * @Date: 2019-10-21 13:21:54
 * @LastEditTime: 2020-04-24 12:12:00
 * @LastEditors: 山淑兰
 */
const wx = window.wx

export default class Wx {
  constructor(opts) {
    this._opt = {
      opt: opts.opt,
    }
    this.init(this._opt.opt)
  }
  init(opt) {
    const {
      AppId,
      Timestamp,
      NonceStr,
      Signature,
      jsApiList = [
        'updateAppMessageShareData',
        'updateTimelineShareData',
        'openLocation',
        'chooseWXPay',
        //'chooseInvoiceTitle',
      ],
    } = opt

    wx.config({
      //beta: true,
      debug: false,
      appId: AppId,
      timestamp: Timestamp,
      nonceStr: NonceStr,
      signature: Signature,
      jsApiList: jsApiList,
    })
    wx.error(function(res) {
      console.error('微信配置:', res)
    })
  }

  ready() {
    return new Promise((resolve) => {
      wx.ready(() => {
        resolve(wx)
      })
    })
  }
  /**
   * @description 微信分享
   */
  share(title, desc, link, imgUrl) {
    wx.updateAppMessageShareData({
      title,
      desc,
      link,
      imgUrl,
    })
    wx.updateTimelineShareData({
      title,
      desc,
      link,
      imgUrl,
    })
  }
  /**
  /**
   * @description 微信获取用户抬头
   */
   // invoice(){
   //  wx.invoke('chooseInvoiceTitle ', { "scene":"1" }, function(res) {
   //    //console.log(res)
   //  });
   // }
  /**
   * @description 微信内置地图
   * @param: {number} lat 纬度，浮点数，范围为90 ~ -90
   * @param: {number} lng  经度，浮点数，范围为180 ~ -180。
   * @param: {string} name  位置名
   * @param: {string} address  地址详情说明
   */
  map(lat, lng, name, address) {
    console.log(lat, lng, name, address)
    wx.openLocation({
      latitude: parseFloat(lat),
      longitude: parseFloat(lng),
      name,
      address,
      scale: 16, // 地图缩放级别,整形值,范围从1~28。默认为最大
      infoUrl: '', // 在查看位置界面底部显示的超链接,可点击跳转
    })
  }

  /**
   * 微信支付
   */
  jsApiCall(par) {
    wx.WeixinJSBridge.invoke('getBrandWCPayRequest', par.payParm, function(
      res
    ) {
      wx.WeixinJSBridge.log(res.err_msg)
      if (res.err_msg == 'get_brand_wcpay_request:ok') {
        // var entity = {
        //   orderid: par.Orderid,
        // }
        //queryQrder(entity)+ JSON.stringify(res)
        // wx.timer = setInterval(queryQrder(entity), 3000)
      } else {
        console.log('您取消了支付', 'error')
        // $.toptip('您取消了支付', 'error')
      }
    })
  }
}
